import onload from "./utils/onload";
import {html} from "./utils/environment";

import draggablegallery from "./components/draggable-gallery";
import dropmenu from "./components/drop-menu";
import floatingBtn from "./components/floating-btn";
import hamburger from "./components/hamburger";
import lightbox from "./components/lightbox";
import map from "./components/map";
import modalvideo from "./components/modal-video";
import modalwindow from "./components/modal-window";
import scroll from "./components/scroll";
import tabs from "./components/tabs";

onload(() => {
    console.log("App JS Started");

    html.classList.add("is-loaded");
    html.classList.add("is-ready");
    html.classList.remove("is-loading");

    draggablegallery();
    dropmenu();
    floatingBtn();
    hamburger();
    lightbox();
    map();
    modalvideo();
    modalwindow();
    scroll();
    tabs();
});
